import { Injectable, NgZone } from '@angular/core'
import { Router } from '@angular/router'
import { AppPaths } from '@ftr/routing-paths'

@Injectable({
  providedIn: 'root',
})
export class ErrorPageService {
  constructor(
    private readonly router: Router,
    private readonly ngZone: NgZone,
  ) {}

  /**
   * Note: userMessage and developerMessage can be undefined
   * @param err
   */
  showForbiddenPage(err?: any): void {
    this.ngZone.run(() => {
      this.router.navigate([`/${AppPaths.Forbidden}`], {
        state: {
          userMessage: err?.details?.userMessage || err?.userMessage,
          developerMessage: err?.details?.developerMessage || err?.developerMessage,
        },
      })
    })
  }

  showForbiddenPageWithMessage(message: string): void {
    this.showForbiddenPage({
      details: {
        userMessage: message,
      },
    })
  }

  showNotFoundPage(): void {
    this.ngZone.run(() => {
      this.router.navigate([`/${AppPaths.NotFound}`], {
        skipLocationChange: true,
      })
    })
  }
}
